import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
  Location,
  Calender,
  CheckCirclIcon,
  ChevronRightArrow,
} from "../../../components/svgs";
import {
  Button,
  StyledText,
  MainHolder,
  Children,
  Body,
  DynamicButton,
  StyledTextInput,
} from "../../../components/common/basic";
import {
  AlertModal,
  BackButton,
  FeatureHeader,
  FullScreenSelect,
} from "../../../components/common";
import useYPYC from "./hooks/useYPYC";
import CircularRadioInput from "../../../components/common/CircularRadioInput";

const YPYCRegistrationForm = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "YPYCRegistrationForm",
        firebase_screen_class: "YPYCRegistrationForm",
      })
    );
  }, []);
  const [ActivePage, setActivePage] = useState();
  const [page, setPage] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const numberOfSteps = 3;
  const {
    background,
    history,
    attendanceOptions,
    handleChange,
    state,
    ypycStatus,
    setYPYCStatus,
    validateForm,
    submitForm,
    countries,
    token,
  } = useYPYC();

  const switchPage = (page) => {
    setPage(page);
  };

  const nextPage = () => {
    const next = page + 1;
    if (page === numberOfSteps - 1) {
      submitForm(state);
    }

    // if (next > 1) validateForm();

    if (next < 3) {
      if (page !== 0 && !validateForm()) return;
      switchPage(next);
    }
  };

  useEffect(() => {
    const compData = {
      state,
      handleChange,
      background,
      attendanceOptions,
      countries,
      gotoEditPage: () => setPage(1),
    };
    switch (page) {
      case 0:
        setActivePage(<AttendanceSelectionPage {...compData} />);
        setDisableSubmit(
          !state?.attendanceOption || state?.attendanceOption === ""
        );
        break;
      case 1:
        setActivePage(<ContactDetailsPage {...compData} />);
        break;
      case 2:
        setActivePage(<SummaryPage {...compData} />);
        break;
      default:
        setActivePage(<AttendanceSelectionPage {...compData} />);
        break;
    }
  }, [page, state]);

  useEffect(() => {
    if (page !== 0) setDisableSubmit(state?.errors?.length > 0);
  }, [state?.errors, page]);

  useEffect(() => {
    if (ypycStatus?.success === true) {
      setShowAlert(true);
    }
    if (ypycStatus?.success === false) {
      setShowAlert(true);
    }
  }, [ypycStatus?.success]);

  return (
    <>
      <MainHolder>
        <BackButton
          onClick={() => {
            if (page < 1) {
              history.goBack();
            } else {
              switchPage(page - 1);
            }
          }}
        />
        <Children>
          <Header>
            <div style={{ textAlign: "center" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium" }}
                margin="0"
              >
                {" "}
              </StyledText>
            </div>
          </Header>
          <Body>
            {
              // TODO: Update success property
              showAlert && (
                <AlertModal
                  background={background}
                  success={ypycStatus?.success}
                  onClick={() => {
                    setYPYCStatus({});
                    setShowAlert(false);
                  }}
                >
                  <div>
                    <StyledText size={24}>
                      Registration{" "}
                      {ypycStatus?.success ? "successful" : "failed"}
                    </StyledText>
                    <div
                      style={{
                        width: "70%",
                        minWidth: "300px",
                        margin: "0 auto 30px auto",
                      }}
                    >
                      <StyledText
                        size={12}
                        style={{
                          fontFamily: "MTNRegular",
                        }}
                      >
                        {ypycStatus?.success
                          ? `Zoom meeting link will be sent to you via SMS and email address. Join via meeting link on given day and time to be a part of the event.`
                          : ypycStatus?.message ||
                            "Sorry, an unexpected error occurred!"}
                      </StyledText>
                    </div>
                    <DynamicButton
                      onClick={() => {
                        setYPYCStatus({});
                        history.push(`/home?token=${token}`);
                      }}
                      label={ypycStatus?.success ? "Great!" : "Ok"}
                      disabled={false}
                      color={background}
                      fullWidth
                    />
                  </div>
                </AlertModal>
              )
            }

            <div
              style={{ boxSizing: "border-box", padding: "0 15px 50px 15px" }}
            >
              <div style={{ padding: "20px 0 20px 0" }}>
                <Stepper
                  currentPage={page}
                  background={background}
                  navigateFunc={switchPage}
                  steps={["Details", "Contact", "Complete"]}
                />
              </div>
              {ActivePage}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={nextPage}
                    label={
                      ypycStatus?.loading
                        ? "Processing..."
                        : page !== 1
                        ? page !== 2
                          ? "Continue"
                          : "Complete"
                        : "Register"
                    }
                    disabled={disableSubmit || ypycStatus?.loading}
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const AttendanceSelectionPage = ({
  state,
  handleChange,
  background,
  attendanceOptions,
}) => {
  return (
    <>
      <div>
        <StyledText size={36} style={{ fontFamily: "MTNMedium" }} margin="0">
          {"YPYC Transform Summit 2024"}
        </StyledText>
        <StyledText
          size={12}
          style={{ fontFamily: "MTNRegular", margin: "10px 0" }}
          margin="0"
        >
          The Great Hall, Kwame Nkrumah University of Science and Technology,
          Kumasi, Ashanti Region-Ghana.
        </StyledText>
        <StyledText size={12} style={{ fontFamily: "MTNMedium" }} margin="0">
          6th July 2024 - 12:00PM
        </StyledText>
      </div>

      <HorizontalLine />

      <div
        style={{
          paddingTop: "10px",
        }}
      >
        <StyledText
          size={13}
          style={{ fontFamily: "MTNMedium", marginBottom: "15px" }}
          margin="0"
        >
          How are you attending
        </StyledText>
        <PulseRadioButton
          selected={state?.attendanceOption}
          background={background}
          options={attendanceOptions.map((val) => ({ label: val, value: val }))}
          onChange={(val) => handleChange("attendanceOption", val)}
        />
      </div>
    </>
  );
};

const SummaryPage = ({ state, background, gotoEditPage }) => {
  return (
    <>
      <div>
        <StyledText size={36} style={{ fontFamily: "MTNMedium" }} margin="0">
          {"YPYC Transform Summit 2024"}
        </StyledText>
        <StyledText
          size={12}
          style={{ fontFamily: "MTNRegular", margin: "10px 0" }}
          margin="0"
        >
          The Great Hall, Kwame Nkrumah University of Science and Technology,
          Kumasi, Ashanti Region-Ghana.
        </StyledText>
        <StyledText size={12} style={{ fontFamily: "MTNMedium" }} margin="0">
          6th July 2024 - 12:00PM
        </StyledText>
      </div>

      <HorizontalLine />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <StyledText size={12} style={{ fontFamily: "MTNMedium" }} margin="0">
          Mode of attendance
        </StyledText>
        <StyledText size={12} style={{ fontFamily: "MTNRegular" }} margin="0">
          {state?.attendanceOption}
        </StyledText>
      </div>

      <HorizontalLine />

      <div
        onClick={gotoEditPage}
        style={{
          padding: "15px",
          border: `1px solid ${background}`,
          borderRadius: "10px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <StyledText
            size={18}
            style={{ fontFamily: "MTNMedium", marginBottom: "10px" }}
            margin="0"
          >
            Edit Contact Details
          </StyledText>
          <StyledText size={12} style={{ fontFamily: "MTNRegular" }} margin="0">
            {`${state?.firstname} ${state?.surname}, ${state?.emailAddress}...`}
          </StyledText>
        </div>
        <ChevronRightArrow width={16} height={16} fill={background} />
      </div>

      {state?.attendanceOption != "In-person" && (
        <div
          style={{
            backgroundColor: "rgba(227, 28, 121, 0.1)",
            padding: "15px",
            marginTop: "15px",
          }}
        >
          <StyledText size={12} style={{ fontFamily: "MTNRegular" }} margin="0">
            Zoom meeting link will be sent to you via SMS and email address.
            Join via meeting link on given day and time to be part of the event.
          </StyledText>
        </div>
      )}
    </>
  );
};

const ContactDetailsPage = ({ state, handleChange, background, countries }) => {
  return (
    <>
      <StyledText
        size={24}
        margin={0}
        style={{ fontFamily: "MTNMedium", marginBottom: "5px" }}
      >
        Contact Details
      </StyledText>
      <StyledText
        size={12}
        margin={0}
        style={{ fontFamily: "MTNRegular", marginBottom: "20px" }}
      >
        Enter your details below
      </StyledText>
      <FormTextField
        placeholder="First name"
        value={state?.firstname}
        hasError={state?.errors?.includes("firstname")}
        onChange={(val) => handleChange("firstname", val)}
        errorMessage="Please enter First Name"
      />
      <FormTextField
        placeholder="Surname"
        value={state?.surname}
        hasError={state?.errors?.includes("surname")}
        onChange={(val) => handleChange("surname", val)}
        errorMessage="Please enter Surname"
      />
      <FormTextField
        placeholder="Email Address"
        value={state?.emailAddress}
        hasError={state?.errors?.includes("emailAddress")}
        onChange={(val) => handleChange("emailAddress", val)}
        errorMessage="Please enter Email Address"
      />
      <HorizontalLine />
      <PulseDropDown
        label={"Country of Origin/Residence"}
        options={countries}
        selected={state?.country}
        hasError={state?.errors?.includes("country")}
        onChange={(val) => handleChange("country", val)}
        errorMessage="Please select Country of Origin/Residence"
      />

      <HorizontalLine />

      <PulseRadioGroup
        label={"College"}
        options={[
          "College of Science",
          "College of Engineering",
          "College of Agriculture & Natural Resource",
          "College of Art & Built Environment",
          "College of Health Sciences",
          "College of Humanities & Social Sciences",
          "Other",
        ]}
        selected={state?.gender}
        hasError={state?.errors?.includes("gender")}
        onChange={(val) => handleChange("gender", val)}
        background={background}
        errorMessage="Please select College"
      />
      <HorizontalLine />

      <PulseDropDown
        label={"Status/Career Status"}
        options={[
          "Employed",
          "Unemployed",
          "Tetiary Student",
          "National Service",
        ]}
        selected={state?.careerStatus}
        hasError={state?.errors?.includes("careerStatus")}
        onChange={(val) => handleChange("careerStatus", val)}
        errorMessage="Please select Status/Career Status"
      />

      <HorizontalLine />

      <FormTextField
        placeholder="Programme/Institution"
        value={state?.organization}
        hasError={state?.errors?.includes("organization")}
        onChange={(val) => handleChange("organization", val)}
        errorMessage="Please enter Programme/Institution"
      />
      <HorizontalLine />

      <PulseRadioGroup
        label={"Year"}
        options={[
          "Year 1",
          "Year 2",
          "Year 3",
          "Year 4",
          "Year 5",
          "Year 6",
          "Other",
        ]}
        selected={state?.studentLevel}
        hasError={state?.errors?.includes("studentLevel")}
        onChange={(val) => handleChange("studentLevel", val)}
        background={background}
        errorMessage="Please indicate your Level"
      />
      {state?.studentLevel === "Other" && (
        <FormTextField
          placeholder="Indicate level"
          value={state?.otherStudentLevel}
          hasError={state?.errors?.includes("otherStudentLevel")}
          onChange={(val) => handleChange("otherStudentLevel", val)}
          errorMessage="Please enter Your Level"
        />
      )}
      <HorizontalLine />

      <StyledText
        size={14}
        style={{ marginBottom: "5px", fontFamily: "MTNMedium" }}
      >
        Kindly indicate if you want a Certificate of Participation*
      </StyledText>
      <StyledText
        size={12}
        style={{ marginBottom: "5px", fontFamily: "MTNRegular" }}
      >
        If you are interested in acquiring a Certificate, kindly pay an amount
        of Gh¢25.00 by MoMo to 0539586011 for a pre-order. PAYMENTS SHOULD BE
        MADE BY 30TH JUNE 2024
      </StyledText>
      <PulseRadioGroup
        label={""}
        options={["Yes", "No"]}
        selected={state?.wantCertificateOfParticipation}
        hasError={state?.errors?.includes("wantCertificateOfParticipation")}
        onChange={(val) => handleChange("wantCertificateOfParticipation", val)}
        background={background}
        errorMessage="Please indicate"
      />
      <HorizontalLine />
    </>
  );
};

const Stepper = ({ currentPage, navigateFunc, background, steps }) => {
  const activeBgColor = "#00678F";
  const inactiveBgColor = "#C8CBCB";
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ position: "relative", display: "inline-block", zIndex: 1 }}>
        {steps.map((label, index) => {
          const isActive = currentPage >= index;
          return (
            <div
              style={{
                cursor: "pointer",
                display: "inline-block",
                position: "relative",
                marginLeft: index === 0 ? "0" : "-20px",
                padding: `5px 30px 5px 20px`,
                paddingLeft: index === 0 ? "20px" : "30px",
                border: "1px solid #fff",
                borderRadius: "20px",
                color: "#fff",
                zIndex: steps.length - index,
                background: isActive
                  ? steps.length - 1 === index
                    ? background
                    : activeBgColor
                  : inactiveBgColor,
              }}
              key={label}
              onClick={() => (isActive ? navigateFunc(index) : {})}
            >
              <StyledText
                size={10}
                style={{ fontFamily: "MTNMedium" }}
                margin="0"
              >
                {label}
              </StyledText>
              <div
                style={{
                  position: "absolute",
                  right: "7px",
                  top: "3px",
                  visibility: isActive ? "visible" : "hidden",
                }}
              >
                <CheckCirclIcon
                  fill={"#fff"}
                  color={
                    steps.length - 1 === index ? background : activeBgColor
                  }
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const PulseRadioButton = ({ options, selected, background, onChange }) => {
  return (
    <div>
      {options.map(({ label, value }) => {
        const isSelected = selected === value;
        const bgColor = isSelected ? background : "#E0E0E0";
        const textColor = isSelected ? "#FFF" : "#000";
        const circleColor = isSelected ? "#00678F" : "#C7C2C2";
        return (
          <div
            style={{
              display: "flex",
              padding: "10px 15px",
              alignItems: "center",
              borderRadius: "13px",
              marginBottom: "10px",
              background: bgColor,
              boxSizing: "border-box",
            }}
            onClick={() => onChange(value)}
          >
            <div
              style={{
                height: "23px",
                width: "23px",
                borderRadius: "48px",
                boxSizing: "border-box",
                marginRight: "10px",
                border: `3px solid ${circleColor}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: isSelected ? "#fff" : "none",
              }}
            >
              {isSelected && (
                <div
                  style={{
                    height: "13px",
                    width: "13px",
                    background: circleColor,
                    boxSizing: "border-box",
                    borderRadius: "26px",
                  }}
                />
              )}
            </div>
            <StyledText
              size={11}
              style={{ fontFamily: "MTNMedium", color: textColor }}
              margin="0"
            >
              {label}
            </StyledText>
          </div>
        );
      })}
    </div>
  );
};

const FormTextField = ({
  value,
  onChange,
  placeholder,
  hasError,
  errorMessage,
}) => {
  const style = {
    textAlign: "left",
    width: "100%",
    fontSize: "13px",
    maxWidth: "400px",
    padding: "15px 10px",
    margin: "0 auto 5px auto",
    boxSizing: "border-box",
  };
  if (hasError) style.border = "1px solid red";

  return (
    <>
      <StyledTextInput
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        value={value}
        style={style}
      />
      {hasError && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          {errorMessage}
        </StyledText>
      )}
    </>
  );
};

const PulseDropDown = ({
  label,
  options,
  selected,
  onChange,
  hasError,
  errorMessage,
}) => {
  return (
    <div>
      <StyledText
        size={14}
        style={{ marginBottom: "5px", fontFamily: "MTNMedium" }}
      >
        {label}
      </StyledText>
      <FullScreenSelect
        data={options.map((option) => ({ label: option, value: option }))}
        selected={selected}
        placeholder={label}
        activeColor={"#000"}
        setValue={onChange}
        hasError={hasError}
        zIndex={4}
      />
      {hasError && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          {errorMessage}
        </StyledText>
      )}
    </div>
  );
};

const PulseRadioGroup = ({
  label,
  options,
  onChange,
  selected,
  background,
  hasError,
  errorMessage,
}) => {
  return (
    <>
      <StyledText
        size={14}
        style={{ marginBottom: "5px", fontFamily: "MTNMedium" }}
      >
        {label}
      </StyledText>
      {options.map((option) => (
        <div style={{ marginBottom: "7px" }}>
          <CircularRadioInput
            action={() => onChange(option)}
            color={background}
            label={option}
            hasError={hasError}
            checked={selected === option}
          />
        </div>
      ))}
      {hasError && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          {errorMessage}
        </StyledText>
      )}
    </>
  );
};

const Header = styled.div`
  width: 360px;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;

export default YPYCRegistrationForm;
